@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.device

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.passengerdevices.PassengerDeviceDto

object GetLatestPassengerDeviceEndpoint: EndPoint<Unit, GetLatestPassengerDeviceEndpoint.Response>() {
    class Response(
        val passengerDevice: PassengerDeviceDto?,
    )
}